"use client";

import { useEffect } from "react";
import { registerBrowserActions } from "@repo/shared-utils/browserActions";

/**
 * Registers browser protection actions (text selection disable, context menu disable,
 * keyboard shortcut disable) on the client side.
 *
 * Elements with the class "copy-item" are exempt from selection restrictions.
 *
 * Drop this once in the root layout — it renders nothing to the DOM.
 */
export default function BrowserActionsInit() {
  useEffect(() => {
    const cleanup = registerBrowserActions();
    return cleanup;
  }, []);

  return null;
}
